// extracted by mini-css-extract-plugin
export var addToCartButton = "_nw-b";
export var arrowButtonContainer = "_nw-9";
export var arrowButtonIcon = "_nw-a";
export var carouselArrowButton = "_nw-6";
export var carouselElementContainer = "_nw-1";
export var left = "_nw-7";
export var productDisplayCarouselContainer = "_nw-0";
export var productTileContainer = "_nw-2";
export var productTileImage = "_nw-4";
export var productTileImageContainer = "_nw-3";
export var productTileTitle = "_nw-5";
export var right = "_nw-8";
export var sliderOverflow = "_nw-c";